import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=09bf4da9&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=09bf4da9&prod&scoped=true&lang=css"
import style1 from "./HelloWorld.vue?vue&type=style&index=1&id=09bf4da9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf4da9",
  null
  
)

export default component.exports